import { CrossIcon } from 'assets';
import './index.scss';

interface FilterPillProps {
    name: string;
    onRemove: () => void;
    value?: string;
    onClick?: () => void;
}

export default function FilterPill({ name, onRemove, value, onClick }: FilterPillProps) {
    const handleRemove = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onRemove();
    };

    return (
        <div 
            className="filter-pill" 
            onClick={onClick}
        >
            <p>{name}{value ? `: ${value}` : ""}</p>
            <img 
                src={CrossIcon} 
                alt="remove-filter-icon" 
                onClick={handleRemove} 
                className="remove-filter-icon" 
            />
        </div>
    );
}